import { Modal, Typography } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { StyledButton } from "../../Common/Components";
import { useUpdateSeries } from "../../entities/api";
import AddNewSeriesFormWrapper from "./AddNewSeriesFormWrapper";

const validateFormData = ({ data, seasonId }) => {
  const validData = {};

  Object.keys(data)?.forEach((key) => {
    if (key === "maxFixturesNumber" && data?.seriesType !== "BEST_OF") {
      validData[key] = null;
    } else if (key === "startDate" || key === "endDate") {
      validData[key] = data?.[key] ? dayjs(data[key])?.format("YYYY-MM-DD") : null;
    } else if (key === "stageCode") {
      validData[key] = data[key]?.value ?? null;
    } else if (validData[key] === data[key]) {
      delete validData[key];
    } else {
      validData[key] = data[key];
    }
  });

  validData.seasonId = seasonId;

  return validData;
};

const ModalEditSeries = ({ series }) => {
  const { formatMessage } = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const formRef = useRef(null);
  const { seasonId } = useParams();
  const { mutateAsync: updateFn, isPending: isUpdatePending } = useUpdateSeries();

  const handleSetFormRef = useCallback((ref) => {
    formRef.current = ref;
  }, []);

  const handleOpenModal = () => {
    setOpenModal((prev) => !prev);
  };

  const handleSubmitForm = async () => {
    let validData = {};

    try {
      const data = await formRef.current.validateFields();
      validData = validateFormData({ data, seasonId });
      delete validData?.seasonId;
    } catch (e) {
      console.error(e);
      return;
    }

    try {
      await updateFn({
        seriesCode: series?.seriesCode,
        data: validData,
      });
      handleOpenModal();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <StyledButton type={"text"} size="small" onClick={handleOpenModal}>
        {formatMessage({
          id: "edit",
          defaultMessage: "Edit",
        })}
      </StyledButton>
      <Modal
        width={600}
        open={openModal}
        destroyOnClose={true}
        onCancel={handleOpenModal}
        okText={formatMessage({
          id: "update",
          defaultMessage: "Update",
        })}
        onOk={handleSubmitForm}
        okButtonProps={{
          loading: isUpdatePending,
        }}
      >
        <Typography.Title level={4}>
          {series?.nameLocal}
          {" - "}
          {formatMessage({
            id: "series.update",
            defaultMessage: "Update Series",
          })}
        </Typography.Title>
        <AddNewSeriesFormWrapper series={series} formRef={formRef} handleSetFormRef={handleSetFormRef} />
      </Modal>
    </>
  );
};

export default ModalEditSeries;
